import React from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles, Paper, InputBase, IconButton } from '@material-ui/core';
import { Search } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    paper: {
        padding: '2px 4px',
        display: 'flex'
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1
    },
    iconButton: {
        padding: 10
    }
}));

const SearchComponent = (props) => {
    const { root, paper, input, iconButton } = useStyles();
    const { placeholder, value, handleSearch } = props;

    return (
        <Grid className={root} item xs={8}>
            <Paper className={paper}>
                <InputBase
                    className={input}
                    placeholder={placeholder || 'Pretraga...'}
                    onChange={(e) => handleSearch(e)}
                    value={value}
                />
                <IconButton className={iconButton} aria-label="search">
                    <Search />
                </IconButton>
            </Paper>
        </Grid>
    );
}

SearchComponent.propTypes = {
    value: PropTypes.string,
    handleSearch: PropTypes.func,
    placeholder: PropTypes.string
};

export default SearchComponent;
